import { gql } from '@apollo/client';

const GET_FDA_ORG_UNIT_PERFORMANCE_REPORT = gql`
  query GetFdaPerformanceReport($id: Int!) {
    fdaPerformanceOrgUnitReport(id: $id) {
      Id
      Name
      Fei
      Address1
      Address2
      City
      State
      ZipCode
      EnrollmentDate
      AppraisalOrgUnits {
        Id
        Appraisal {
          Id
          Name
          ConductAppraisalEndDate
          AppraisalTeamMembers {
            Individual {
              Id
              Name
            }
            Type
          }
        }
      }
      PerformanceItems {
        Id
        CheckpointId
        MeasurementName
        MeasurementUnit
        Numerator
        Denominator
        QualityDomain
        QualityObjective
        BusinessObjective
        MeasurementLevel
        MeasurementCalculation
        MeasurementDescription
        TimeBounds
        TimeFrame
        GoodPerformanceIndicator
        LimitationsOrBlindSpots
        MeasurementUse
        CaptureFrequency
        ReportFrequency
        IsDiscontinued
        DiscontinuedReason
        ExpirationDate
        TargetDescription
        CustomQualityDomainDefinition
        CheckpointPerformanceItemDataPoints {
          Id
          CheckpointId
          CheckpointPerformanceItemId
          Status
          LowerLimit
          UpperLimit
          Actual
          Notes
          Checkpoints {
            Id
            DataCollectionDate
            ReporterName
            AppraisalOrgUnitsId
          }
        }
      }
      MddapOrganization {
        Id
        Name
      }
      MddapOfficeOfHealthTechnologies {
        Id
        OfficeOfHealthTechnology {
          Id
          Value
        }
      }
    }
  }
`;
export default GET_FDA_ORG_UNIT_PERFORMANCE_REPORT;
